import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Container,
  Link,
  Typography,
} from '@mui/material';
import Logo from '../../components/Logo';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { getRegisterState, State as RegisterState } from '../../reducers/register'
import LayoutPlain from './LayoutPlain';

const Register: FC = () => {
  const registerState: RegisterState = useSelector(getRegisterState)
  const dispatch = useDispatch()
  if (registerState.processing || registerState.success || registerState.domainExists !== true) {
    // these are all unexpected states, potentially illegal entrance;
    // we'll redirect to root, where authorzation is enforced
    dispatch(push('/'))
  }

  return (
    <LayoutPlain>
      <Helmet>
        <title>Register | OnData</title>
      </Helmet>
      <Box
        sx={{ pt: 8 }}
      >
        <Container
          maxWidth="md"
          sx={{
            pl: {
              lg: 15
            }
          }}
        >
          <Typography
            color="textPrimary"
            sx={{ fontWeight: 'fontWeightBold', mt: 5 }}
            variant="h2"
          >
            Account Registration
          </Typography>
          <Typography
            sx={{ py: 3 }}
            color="textPrimary"
            variant="body1"
          >
            Thank you for this registration request! Your organization has already been registered with OnData. We have notified your organization administrator about this request. Your organization administrator may invite you to join OnData. Please feel free to contact the OnData Support Team in case of any questions.
          </Typography>
        </Container>
      </Box>
    </LayoutPlain>
  );
};

export default Register;
